<template>
  <div>	
	<div class="login">
		<img :src="require('@/assets/logo-rci.png')" alt="RCI - Bienvenido"/>
			<form class="vue-form" @submit.prevent="submit" action="" method="post" accept-charset="utf-8">
				<div class="flex-container">
					<label for="username">
						<i class="fa fa-user"></i>
					</label>
					<input type="text" name="username" placeholder="Usuario" id="username" required v-model="data.username">
				</div>
				<div class="flex-container">
					<label for="password">
						<i class="fa fa-lock"></i>
					</label>
					<input type="password" name="password" placeholder="Contraseña" id="password" required v-model="data.password">
				</div>
				<input type="submit" value="Entrar">
			</form>
		</div>
	</div>
</template>

<script>
  import {mapActions,mapState} from 'vuex'

  import axios from 'axios'
  import Vue from 'vue'

  export default {
    data(){
      return{
        data:{
          username:'',
          password:''
        }
      }
    },
    mounted(){
        //this._login(this.data).then(() => { })

    },
    computed:{
        ...mapState('login',['jwt','secret','isLogged','errorMessage','msg'])
    },
    
    methods:{
        ...mapActions({
          _login: 'login/login',
         
          

        }),
        submit(){
		/*	let url = "api/login"//la direccion de la api
			let values = new FormData()
    		values.append('username',this.data.username)
    		values.append('password',this.data.password) 
			Vue.axios({
        		method: 'POST',
        		mode: 'no-cors',
        		withCredentials: true,
        		credentials: 'same-origin',
        		headers: {
        		    'Access-Control-Allow-Origin': '*',
        		    'Content-Type': 'application/json',
        		  },
        		  crossdomain: true,
        		url: url,        
        		data: values
    		})
			*/
           this._login(this.data).then(() => { 
                if(this.isLogged){
					this.$router.push('/home')
					this.$toasted.show(this.msg, { 
	 							theme: "bubble", 
	 							position: "top-right", 
	 							duration : 3000
					})
                }else{
                    this.$toasted.show(this.errorMessage, {
	 					duration : 3000
						})
                }
			})
			
        }

        
    }
  }
</script>

<style lang="scss" scoped>
.fondo {
  	background-color: #435165;
		height: 100vh;
		margin:0;
		padding-top:1px;
}
.login {
  	width: 400px;
  	background-color: #ffffff;
  	box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
  	margin: 100px auto;
	display:flex;
	flex-direction: column;
	  
}
.login h1 {
  	text-align: center;
  	color: #5b6574;
  	font-size: 24px;
  	padding: 20px 0 20px 0;
  	border-bottom: 1px solid #dee0e4;
}
.login img{
	display: block;
	margin-left: auto;
	margin-right: auto;
	width: 60%;
	padding:20px 0;
}
.login form {
  	display: flex;
  	flex-wrap: wrap;
  	justify-content: center;
  	padding-top: 20px;
}
.login .flex-container{
	display:flex
}
.login form label {
  	display: flex;
  	justify-content: center;
  	align-items: center;
  	width: 50px;
  	height: 50px;
  	background-color:#00AC89;;
  	color: #ffffff;
}
.login form input[type="password"], .login form input[type="text"] {
  	width: 310px;
  	height: 50px;
  	border: 1px solid #dee0e4;
  	margin-bottom: 20px;
  	padding: 0 15px;
}
.login form input[type="submit"] {
  	width: 100%;
  	padding: 15px;
 	margin-top: 20px;
  	background-color:#00AC89;
  	border: 0;
  	cursor: pointer;
  	font-weight: bold;
  	color: #ffffff;
  	transition: background-color 0.2s;
}
.login form input[type="submit"]:hover {
	background-color:#86CEBC;
  	transition: background-color 0.2s;
}
@media screen and (max-width: 600px) {
  .login {
		width:90vw;
	}
	.login form{	
		flex-direction: column;
	}
	.login .flex-container{
		justify-content:center;	
	}
	.login form input[type="password"], .login form input[type="text"] {
  	width: 60vw;
  	margin-bottom: 20px;
  	padding: 0 15px;
	}
	
}
</style>